import createVueComponent from '../createVueComponent';

const FileX2 = createVueComponent('FileX2Icon', [
  ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
  ['path', { d: 'M14 2v6h6' }],
  ['path', { d: 'M3 12.5l5 5' }],
  ['path', { d: 'M8 12.5l-5 5' }],
]);

export default FileX2;
